module.exports = __webpack_public_path__ + "assets/img/ground.bb14828f.png";